import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { DefaultErrorMessage } from "shared/constants/message";
import { updateAddressCartApi } from "states/cart/cart.api";
import { UpdateAddressModel } from "states/cart/cart.models";
import { createCustomerAddressApi, getAllCustomerAddressApi, removeCustomerAddressApi, updateCustomerAddressApi } from "states/customer-address/customer-address.api";
import { CustomerAddressModel } from "states/customer-address/customer-address.models";
import { globalValueGetCart, globalValueSetLoading, globalValueSetStepper, globalValueSetToast, globalValueShowConfirmModal } from "states/global-value/global-value.action";
import { ConfirmModel, Stepper, ToastModel, ToastType } from "states/global-value/global-value.models";
import { useDebouncedCallback } from "use-debounce/lib";
import { RootState } from "../../app.store";
import { AddressFormComponent } from "./address-form";
import { AddressItemComponent } from "./address-item";
import "./address.less";
interface AddressProps {}
export const Address = (props: AddressProps) => {
  const dispatch = useDispatch();
  const cart = useSelector(
    (state: RootState) => state.cart,shallowEqual
  );
  const isGetCart = useSelector(
    (state: RootState) => state.globalValue.isGetCart
  );
  const isAuthenticated = useSelector(
    (state: RootState) => state.account.isAuthentication
  );
  const [addressId,setAddressId] = useState<string | number>();
  const [addresses, setAddresses] = useState<CustomerAddressModel[]>([]);
  const [isModal, setIsModal] = useState<boolean>(false);
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const [isRedirect, setIsRedirect] = useState<boolean>(false);
  const _handleRemoveAddress = async (id: string | number) => {
    if(id === cart.addressId){
      dispatch(
        globalValueSetToast({
          message: "Vui lòng xóa địa chỉ khác địa chỉ đang chọn",
          type: ToastType.error,
        } as ToastModel)
      );
      return false;
    }
    dispatch(globalValueSetLoading(true));
    try {
      await removeCustomerAddressApi(id);
      initData.callback();
      setIsModal(false);
      dispatch(globalValueSetLoading(false));
    } catch (error) {
      dispatch(
        globalValueSetToast({
          message: error?.response?.data?.error?.message ?? DefaultErrorMessage,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  const _handleUpdateAddressCart = async (id: string | number) => {
    dispatch(globalValueSetLoading(true));
    try {
      await updateAddressCartApi({ addressId: id} as UpdateAddressModel);
      dispatch(globalValueGetCart(!isGetCart));
      setIsRedirect(true);
      dispatch(globalValueSetLoading(false));
    } catch (error) {
      dispatch(globalValueSetLoading(false));
      dispatch(
        globalValueSetToast({
          message: error?.response.data,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  const _handleUpdateAddressCustomer = async (
    address: CustomerAddressModel
  ) => {
    dispatch(globalValueSetLoading(true));
    try {
      await updateCustomerAddressApi(address);
      initData.callback();
      dispatch(globalValueSetLoading(false));
    } catch (error) {
      dispatch(globalValueSetLoading(false));
      dispatch(
        globalValueSetToast({
          message: error?.response.data,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  const _handleCreatedAddressCustomer = async (
    address: CustomerAddressModel
  ) => {
    dispatch(globalValueSetLoading(true));
    try {
      let response = await createCustomerAddressApi(address);
      initData.callback();
      await _handleUpdateAddressCart(response.data);
      setIsModal(false);
      setIsRedirect(true);
      dispatch(globalValueSetLoading(false));
    } catch (error) {
      dispatch(globalValueSetLoading(false));
      dispatch(
        globalValueSetToast({
          message: error?.response.data,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  const redirect = () =>{
    if(!isRedirect) return false;
    return <Redirect to="/cart/checkout" />
  }
  const _handleGetAddress = async () =>{
    dispatch(globalValueSetLoading(true));
    try{
      let result = await getAllCustomerAddressApi();
      dispatch(globalValueSetLoading(false));
      setAddresses(result.data);
    }catch(error){
      dispatch(globalValueSetLoading(false));
      dispatch(
        globalValueSetToast({
          message: error?.response?.data?.error?.message ?? DefaultErrorMessage,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  };
  const initData = useDebouncedCallback(()=>{
    _handleGetAddress();
  },1000)
  useEffect(() => {
    if(isAuthenticated){
      initData.callback();
    }
  }, [cart,isAuthenticated]);
  useEffect(() => {
    document.title = "Địa chỉ giao hàng";
    dispatch(globalValueSetStepper(Stepper.Address));
  }, []);
  return (
    <React.Fragment>
      <div className="address-item-container flex-container">
        {addresses.map((address) => (
            <AddressItemComponent
              name={address?.name}
              phone={address?.phoneNumber}
              address={address.address}
              wardName={address.wardName}
              districtName={address.districtName}
              provinceName={address.provinceName}
              addressIdUseCart={cart.addressId}
              addressId={address.id}
              onEdit={(addressId) => {
                setIsUpdate(true);
                setAddressId(addressId);
                setIsModal(true);
              }}
              onSelect={ async (addressId) => {
                await _handleUpdateAddressCart(addressId);
              }}
              onRemove={(addressId) => {
                dispatch(globalValueShowConfirmModal({ 
                  isModal: true,
                  message:"Bạn có muốn xóa địa chỉ này không",
                  onYes: (ev: any) => { 
                    ev.preventDefault(); 
                    _handleRemoveAddress(addressId);
                    dispatch(globalValueShowConfirmModal({isModal: false}));
                  },
                  onClose: () => { 
                    dispatch(globalValueShowConfirmModal({isModal: false}));
                  }
                } as ConfirmModel));
              }}
            />
          ))}
      </div>
      <div className="address-container-footer">
        <div className="address-text p-2">
          Bạn có muốn sử dụng địa chỉ khác không ?
          <button
            onClick={() => {
              setIsUpdate(false);
              setIsModal(true);
            }}
            className="text-primary"
          >
           Thêm địa chỉ giao hàng
          </button>
        </div>
        <AddressFormComponent
          isModal={isModal}
          isUpdate={isUpdate}
          addressId={addressId as number}
          onModal={(isModal) => {
            setIsModal(isModal);
          }}
          onUpdate={async (address: CustomerAddressModel) => {
            await _handleUpdateAddressCustomer(address);
          }}
          onAdd={async (address: CustomerAddressModel) => {
            await _handleCreatedAddressCustomer(address);
          }}
        />
      </div>
      {redirect()}
    </React.Fragment>
  );
};
